import { render, staticRenderFns } from "./WidgetCookie.vue?vue&type=template&id=e6e74a96&scoped=true&lang=pug&"
import script from "./WidgetCookie.vue?vue&type=script&lang=js&"
export * from "./WidgetCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e74a96",
  null
  
)

export default component.exports